@if (filterForm != null) {
    <h2 class="expand-header" [class.expanded]="this.filterForm().expanded().value()" (click)="toggleExpanded()">Tidsperiode</h2>
  
    <div class="expander timeperiod" [class.expanded]="this.filterForm().expanded().value()">
        @if (validationErrors().length > 0) {
            <div class="validation-error" role="alert" data-cy="timePeriodValidationError">
                <div class="error-icon"></div>
                <div class="error-message">
                    @for (message of validationErrors(); track message) {
                        <div>{{ message }}</div>
                    }
                </div>
            </div>
        }

        <ev-time-period-filter
            [showAllOptionInRange]="true"
            [rangeToMonthList]="rangeToMonthListValue()"
            [defaultValue]="defaultValue"
            [selectedPeriod]="selectedValue"
            (onTimePeriodChange)="onChange($event)"
        ></ev-time-period-filter>
    </div>
}
